import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/icons/sprite.svg'


const _hoisted_1 = _imports_0 + '#backBtn'
const _hoisted_2 = _imports_0 + '#search'
const _hoisted_3 = { class: "find" }

import router from "@/router";
  import Input from "@/UI/Input.vue";
  import { ref, watch } from "vue";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Find',
  props: {
    modelValue: {
      type: String,
    },
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

  const props = __props;

  const modelValue = ref(props.modelValue);
  
  const emit = __emit;

  watch(
    () => modelValue.value,
    () => {
      emit("update:modelValue", modelValue.value);
    }
  );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_3, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("svg", {
        width: "36",
        height: "36"
      }, [
        _createElementVNode("use", { "xlink:href": _hoisted_1 })
      ], -1)
    ])),
    _createVNode(Input, {
      class: "find__input",
      isNoActivePlaceholder: true,
      type: "text",
      placeholder: "Найти продукты",
      isIcon: true,
      modelValue: modelValue.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue).value = $event))
    }, {
      icon: _withCtx(() => _cache[3] || (_cache[3] = [
        _createElementVNode("svg", {
          width: "16",
          height: "16"
        }, [
          _createElementVNode("use", { "xlink:href": _hoisted_2 })
        ], -1)
      ])),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})